import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class DeliveriesValidationTableCtrl implements IController {
  orders: any;
  selectedIds: any;
  isEditable: any;
  queryString: any;
  onSelectedIdsChanged: Function;
  onRemove: Function;
  onEdit: Function;

  private selectedKeys: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.selectedKeys = {};
    _.forEach(this.selectedIds, (selectedId) => {
      this.selectedKeys[selectedId] = true;
    });
  }


  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this.$onInit();
    }
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onToggleDelivery(orderId) {
    const selectedIds = _.map(this.selectedKeys, (value, key) => {
      if (value) return key;
    });
    this.onSelectedIdsChanged({selectedIds: _.compact(selectedIds)});
  }

  onToggleAllDeliveries() {
    var selectedIds = !_.isEqual(this.selectedIds.length, this.orders.length) ?
      _.map(this.orders, (order) => {
        return order.orderId;
      }) : [];

    this.onSelectedIdsChanged({selectedIds: selectedIds});
  }

  onRemoveDelivery(id) {
    this.onRemove({ids: [id]});
  }

  onEditDelivery(order) {
    this.onEdit({order: order})
  }
}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveriesValidationTable', {
    bindings: {
      orders: '<',
      selectedIds: '<',
      isEditable: '<',
      queryString: '<',
      onSelectedIdsChanged: '&',
      onRemove: '&',
      onEdit: '&'
    },
    template: require('./deliveries-validation-table.html').default,
    controller: DeliveriesValidationTableCtrl
  });
